"use client";

import { SenseiMark } from "@/shared/components/layout/SenseiMark";

/**
 * Inline "limit reached" dialog — free users hit this when they try to do
 * something reserved for Pro (generate a 2nd pack, duplicate, download).
 */
export default function UpgradeDialog({
  title = "Free plan limit reached",
  message,
  onClose,
}: {
  title?: string;
  message: string;
  onClose: () => void;
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 120,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        backdropFilter: "blur(8px)",
        animation: "fadeIn .2s ease",
      }}
    >
      <div
        style={{
          background: "var(--pk-paper)",
          border: "1px solid var(--pk-line-strong)",
          borderRadius: 20,
          padding: "36px 32px 24px",
          maxWidth: 420,
          width: "100%",
          textAlign: "center",
          boxShadow: "0 24px 60px rgba(0,0,0,0.35)",
          animation: "popIn .25s ease",
        }}
      >
        <div className="diag-logo-wrap">
          <SenseiMark size={56} />
        </div>
        <h3 style={{ margin: "20px 0 8px", fontSize: 20, fontWeight: 600, color: "var(--pk-ink)" }}>{title}</h3>
        <p style={{ margin: "0 auto 20px", color: "var(--pk-muted)", fontSize: 13.5, lineHeight: 1.6, maxWidth: 320 }}>
          {message}
        </p>
        <a
          href="/checkout?plan=pro_monthly"
          style={{
            width: "100%", border: "none", borderRadius: 12, padding: "13px 18px",
            fontSize: 15, fontWeight: 650, cursor: "pointer", color: "#fff", textDecoration: "none",
            display: "inline-block",
            background: "linear-gradient(135deg, var(--indigo), var(--magenta))",
          }}
        >
          Upgrade to Pro
        </a>
        <button
          type="button"
          onClick={onClose}
          style={{ background: "none", border: "none", color: "var(--pk-muted)", fontSize: 13, cursor: "pointer", marginTop: 14, display: "block", width: "100%" }}
        >
          Not now
        </button>
      </div>
    </div>
  );
}